import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import Navbar from '../components/Navbar';
import PageHero from '../components/PageHero';
import GrowthROI from '../components/GrowthROI';
import ProcessSteps from '../components/ProcessSteps';
import DocumentsRequired from '../components/DocumentsRequired';
import GuaranteeCard from '../components/GuaranteeCard';
import Pricing from '../components/Pricing';
import Comparison from '../components/Comparison';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';
import { ContactSection, Footer } from '../components/Footer';
import { stateLocations } from '../data/states';

export default function VpobApobPage() {
  useEffect(() => {
    document.title = 'VPOB & APOB Services across India | EasyWorks';
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF2E8] font-[Inter]" data-testid="vpob-apob-page">
      <Navbar />
      <PageHero
        eyebrow="VPOB & APOB"
        headline="Multi-state VPOB, one"
        headlineAccent="simple platform"
        description="Register and manage Section 35-compliant Virtual Places of Business (VPOB) and Additional Places of Business (APOB) for GST across India — built for Amazon, Flipkart, Meesho, JioMart and Myntra sellers."
        category="vpob"
        subtype="General"
        service="VPOB & APOB"
        formTitle="Get a VPOB quote"
        formTestId="vpob-quote-form"
      />

      <GrowthROI />

      <section className="bg-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">All locations</div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-neutral-900">Get your Virtual Office across Multiple States</h2>
          <p className="mt-3 text-[15px] text-neutral-600 max-w-xl">
            Click any state to view pricing, coverage cities and start your VPOB registration.
          </p>
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {stateLocations.map((s) => (
              <Link
                key={s.slug}
                to={`/virtual-office-in/${s.slug}`}
                data-testid={`vpob-state-${s.slug}`}
                className="group bg-white border border-black/5 rounded-2xl p-4 hover:border-[#F39200] hover:shadow-md transition-all"
              >
                <div className="flex items-center justify-between">
                  <div className="w-10 h-10 rounded-lg bg-[#FAF2E8] text-[#F39200] flex items-center justify-center font-extrabold text-sm">
                    {s.code}
                  </div>
                  <span className="text-[11px] text-neutral-500">From ₹{s.price}/mo</span>
                </div>
                <div className="mt-3 text-sm font-semibold text-neutral-900">{s.name}</div>
                <div className="mt-1 text-[11px] text-neutral-500 flex items-center gap-1 truncate">
                  <MapPin size={11} className="shrink-0" /> {s.cities[0]}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <ProcessSteps />
      <DocumentsRequired />
      <GuaranteeCard />
      <Pricing />
      <Comparison />
      <Reviews />
      <FAQ />
      <ContactSection />
      <Footer />
    </div>
  );
}
